// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8140431d","678":"6b433274"}[chunkId] + ".chunk.js";
};